import { styled } from '@mui/material';
import clsx from 'clsx';

import {
  IconButton,
  IconButtonProps,
  iconButtonVars,
  tokens,
} from '@cast/design-system';

type HeaderIconButtonProps = {
  active?: boolean;
} & Omit<IconButtonProps, 'size' | 'variant'>;

export const HeaderIconButton = styled(
  ({ className, active, children, ...rest }: HeaderIconButtonProps) => {
    return (
      <IconButton {...rest} className={clsx(className, { active })} size="sm">
        {children}
      </IconButton>
    );
  }
)(() => ({
  ...iconButtonVars.setValues({
    color: tokens.theme.fg.structural.secondary,
    colorActive: tokens.theme.fg.action.primary,
    colorDisabled: tokens.theme.disabled.fg,
    background: 'unset',
    backgroundHover: tokens.theme.bg.action.ghostHover,
    backgroundActive: tokens.theme.bg.selection.primarySubtle,
    backgroundDisabled: 'unset',
    iconSize: '20px',
  }),

  width: '32px',
  height: '32px',
  minWidth: '32px',
  minHeight: '32px',
  borderRadius: '4px',
}));
